module.exports = __webpack_public_path__ + "img/TOCTemp3.55c989ad.png";